import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RutaProtegida({ children, soloAdmin = false }) {
    const { usuario, cargando } = useAuth();
    if (cargando) {
        return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;
    }
    if (!usuario) return <Navigate to="/login" replace />;
    if (soloAdmin && usuario.rol !== 'administrador') return <Navigate to="/" replace />;
    return children;
}
